import { render, staticRenderFns } from "./trainInvitation.vue?vue&type=template&id=24a66c6a&scoped=true&"
import script from "./trainInvitation.vue?vue&type=script&lang=js&"
export * from "./trainInvitation.vue?vue&type=script&lang=js&"
import style0 from "./trainInvitation.vue?vue&type=style&index=0&id=24a66c6a&lang=scss&scoped=true&"
import style1 from "./trainInvitation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a66c6a",
  null
  
)

export default component.exports